import getEnvironment from "../getEnvironment";

export interface VehicleDetailsPageParams {
  inventoryID: string;
  filterDate: string;
}

const buildVehicleDetailsPageUrl = (
  queryParams: VehicleDetailsPageParams,
  vrm: string
) => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const buyerAPIDomain = isProd
    ? "https://www.bca.co.uk"
    : "https://cms.uat.britishcarauctions.net";
  const url = new URL(`${buyerAPIDomain}/lot/${vrm}?source=Purchases&vdr=pu`);

  Object.keys(queryParams).forEach((param) => {
    url.searchParams.set(param, queryParams[param]);
  });

  return url.href;
};

export default buildVehicleDetailsPageUrl;
